import { getVal } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import moment from 'moment/moment'

/**
 * 审核状态
 * @type {{getValOrCol(*): {color: (*|string), value: (*|string)}, APPROVE: string[], WAIT: string[], REFUSE: string[]}}
 */
export const AuditStateEnum = {
  // 待处理
  WAIT: ['0', '待处理', 'blue'],
  //申请通过
  APPROVE: ['1', '申请通过', 'green'],
  //申请不通过
  REFUSE: ['2', '申请不通过', 'red'],
  getValOrCol (flag) {
    return getVal(flag, AuditStateEnum)
  },
  getList () {
    return getKeyWithValList(AuditStateEnum)
  }
}
/**
 * 获取key和val的list
 */
const getKeyWithValList = (enumE) => {
  return Object.keys(enumE).filter(item => typeof enumE[item] !== 'function').map(
    item => {
      return {
        val: enumE[item][0],
        text: enumE[item][1]
      }
    }
  )
}

/**
 * 申请类型跳转审核页
 * @type {{}}
 */
export const ApplyForTypeEnum = {
  // 专家入库申请
  APPLY_FOR_TYPE_ENTER: ['1', '入库', 'invVisible'],
  // 专家出库申请
  APPLY_FOR_TYPE_OUT: ['2', '出库', 'outVisible'],
  // 专家修改品目申请
  APPLY_FOR_TYPE_EDIT_ITEM: ['3', '修改品目', 'itemVisible'],
  getAuditObj (flag) {
    return getObj(flag, ApplyForTypeEnum)
  },
  getList () {
    return getKeyWithValList(ApplyForTypeEnum)
  }
}

/**
 * 获取对象
 * @param flag
 * @param enumE
 * @returns {{visible: (*|undefined), text: (*|undefined), value: (*|undefined)}}
 */
const getObj = (flag, enumE) => {
  let val = Object.keys(enumE).filter(item => enumE[item][0] === flag
  )[0]
  return {
    value: val ? enumE[val][0] : undefined,
    text: val ? enumE[val][1] : undefined,
    visible: val ? enumE[val][2] : undefined
  }
}

/**
 * 申请列表列
 * @type {[{customRender: (function(*): *), dataIndex: string, title: string},{scopedSlots: {customRender: string}, dataIndex: string, title: string},{scopedSlots: {customRender: string}, dataIndex: string, title: string},{customRender: (function(*): string|string), dataIndex: string, title: string},{customRender: (function(*): *|string), dataIndex: string, title: string},null,null]}
 */
export const ApplyForColumns = [
  {
    title: '提交时间',
    dataIndex: 'createDate',
    customRender: (text) => {
      return text && moment(text).format('YYYY-MM-DD HH:mm')
    }
  },
  {
    title: '申请类型',
    dataIndex: 'applyForType',
    scopedSlots: { customRender: 'applyForType' }
  },
  {
    title: '申请人',
    dataIndex: 'applyForTitle',
    scopedSlots: { customRender: 'applyForTitle' }
  },
  {
    title: '处理时间',
    dataIndex: 'auditDate',
    customRender: (text) => {
      return text ? moment(text).format('YYYY-MM-DD HH:mm') : '待处理'
    }
  },
  {
    title: '处理人',
    dataIndex: 'auditUserName',
    customRender: (text) => {
      return text ? text : '待处理'
    }
  },
  {
    title: '处理结果',
    dataIndex: 'auditState',
    scopedSlots: { customRender: 'auditState' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '180px',
    scopedSlots: { customRender: 'operation' }
  }
]
